import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './chargingProgress.css';
import { percentageCharged } from './percentageCharges';

function getActiveDotIndex(percent) {
  if (percent == null) return 0;
  const p = parseFloat(percent);
  if (p <= 25) return 0;
  if (p <= 50) return 1;
  if (p <= 75) return 2;
  if (p < 100) return 3;
  return 4; // all charged
}

export default function ChargingProgress({
  status,
  online,
  widthContainer,
  marginContainer,
  widthDot,
  heightDot,
  periodKwt,
  carKwtKmRatio,
  showKmLabel = false,
}) {
  const [percent, setPercent] = useState();
  const [rangeError, setRangeError] = useState(false);
  const { t } = useTranslation();

  const dotWidth = widthDot ?? '52px';
  const dotHeight = heightDot ?? '52px';

  useEffect(() => {
    if (status?.periodS) {
      const result = percentageCharged(status?.periodS, status?.leftS, status?.type, setRangeError);
      setPercent(result);
    }
    if (status?.periodKwt) {
      const result = percentageCharged(status?.periodKwt, status?.leftWt, status?.type, setRangeError);
      setPercent(result);
    }
  }, [status]);

  const kmPerDot = useMemo(() => {
    const period = periodKwt ?? status?.periodKwt ?? 0;
    const whPerKm = carKwtKmRatio ?? 200;
    if (!period || period === 220) return [0, 0, 0, 0];
    return [0.25, 0.5, 0.75, 1].map(frac => Math.round((frac * period * 1000) / whPerKm));
  }, [periodKwt, status?.periodKwt, carKwtKmRatio]);

  const activeIndex = getActiveDotIndex(percent);
  const onlineBlinkingStatus = online ? 'dotItemActive' : 'dotItemDefault';

  const dots = [0, 1, 2, 3].map(i => {
    let state = 'dotItemDefault';
    if (i < activeIndex) state = 'dotItemCharged';
    else if (i === activeIndex && activeIndex < 4) state = onlineBlinkingStatus;
    return { key: i, state, km: kmPerDot[i] };
  });

  return (
    <div style={{ width: widthContainer ?? '120px', margin: marginContainer ?? '0 auto 5px' }}>
      {!rangeError ? (
        <div className={`dotsBox ${showKmLabel ? 'dotsBoxWithKm' : 'dotsBoxLegacy'}`}>
          {dots.map(({ key, state, km }) => (
            <div
              key={key}
              className={`dotItem ${showKmLabel ? 'dotItemWithKm' : ''} ${state}`}
              style={{ width: dotWidth, height: dotHeight }}
            >
              {showKmLabel && (
                <>
                  <span className="dotKmValue">{km}</span>
                  <span className="dotKmUnit">{t('km')}</span>
                </>
              )}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
